import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { Store } from '@ngrx/store';
import * as vaultSelector from '../../../../../../root-store/vault-store/vault.selector';
import { HttpClient } from '@angular/common/http';
import { AttributesDialogComponent } from '../attributes-dialog/attributes-dialog.component';
import { BalanceSubjectService } from '@app/shared/component/current-balance-card/balance-attribute-subject-behavior';
import { DynamicSubjectService } from '@app/shared/component/dynamic-attributes/dynamic-attribute-subject-behavior';
import { FetchAttributeDataSubject } from '../../add-finacial-attribute/attribute-subject.service';
import { DynamicAttributesComponent } from '@app/shared/component/dynamic-attributes/dynamic-attributes.component';
import { CurrentBalanceCardComponent } from '@app/shared/component/current-balance-card/current-balance-card.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'insurance-attributes',
  templateUrl: './insurance-attributes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceAttributesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() currentFormId;
  @Input() userId;
  @Input() attribute_class;
  @Input() attribute_sub_class;
  @Input() fId;
  @Input() data;
  @Input() connected_to_institution;
  @Input() currentValutUserId;
  @Input() mode;
  @Input() isRemoveEditSaveSharing;
  @Input() name;
  @Input() currentuserId;
  @Input() has_death_benefit;
  @Input() countList;
  @Input() templateId = null;
  @Input() on_boarding_insurance = [];
  @Input() is_onboarding = false;
  @Input() income_expense_class = '';
  @Input() income_expense_sub_class = '';
  @Output() setupItemEmitter = new EventEmitter<any>();
  @ViewChild('dynamicAttributesComponent') appDynamicAttributes: DynamicAttributesComponent;
  @ViewChild(CurrentBalanceCardComponent) currentBalanceCardComponent: CurrentBalanceCardComponent;
  subscription = new Subscription();
  multipleValues = false;
  attributes = [];
  isAttributeLoading: WritableSignal<boolean> = signal(true);
  hasInsuranceAttribute: WritableSignal<boolean> = signal(false);
  insuranceAttributes = [];
  has_death_ben;
  commonAttr = [
    'Individual Deductible',
    'Family Deductible',
    'Individual Out of Pocket Maximum',
    'Family Out of Pocket Maximum',
    'Insurance Deductible',
  ];
  insuranceFormData;
  attributesList: WritableSignal<Array<any>> = signal([]);
  reload = false;
  constructor(
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private store: Store,
    private vaultService: VaultStoreEffects,
    private http: HttpClient,
    private dialog: MatDialog,
    private balanceDataBehaviorSubject: BalanceSubjectService,
    private dynamicSubjectService: DynamicSubjectService,
    private attributeSubject: FetchAttributeDataSubject
  ) {}

  ngOnInit(): void {
    // this.getFormData();
    // this.getList();
    this.subscription.add(
      this.dynamicSubjectService.getValues.subscribe((val) => {
        if (val) {
          this.reload = !this.reload;
          // this.attributesList = [];
          // this.insuranceFormData = undefined;
          this.getList();
          // this.getDataForAttributes();
          // this.balanceDataBehaviorSubject.handleBalanceData(val);
          // !!val?.setupItem ? this.setupItemEmitter.emit(val?.setupItem) : '';
        }
      })
    );
    this.subscription.add(
      this.attributeSubject.fetchAttributeData.subscribe((res) => {
        if (res) {
          this.attributesList.set([]);
          this.insuranceFormData = undefined;
          this.getList();
        }
      })
    );
  }
  hasAttributeLoaded = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.data) {
      if (!this.hasAttributeLoaded) this.getList();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  getList() {
    this.hasAttributeLoaded = true;
    this.attributesList.set([]);
    this.insuranceFormData = undefined;
    this.getBalance(this.userId);
    this.subscription.add(
      this.store.select(vaultSelector.getCurrentFormsById(this.data?.form_id ?? this.data?.fid)).subscribe((response) => {
        if (!!response?.insurance_attributes.trim()) {
          this.hasInsuranceAttribute.set(true);
          this.isAttributeLoading.set(false);
          this.insuranceAttributes = response.insurance_attributes.split(',');
          this.getDataForAttributes();
          this.cd.detectChanges();
        } else {
          this.hasInsuranceAttribute.set(false);
          this.cd.detectChanges();
        }
      })
    );
  }
  getDataForAttributes() {
    this.attributesList.set([]);
    this.insuranceAttributes?.forEach((attribute) => {
      this.handleJson(attribute);
    });
    if (this.currentFormId) {
      this.getInsuranceAttributeFormData();
    }

    this.getAttributeClass();
  }
  getAttributeClass() {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          let res = state.forms;

          if (res.length && res.findIndex((x) => x.id == this.fId) != -1) {
            this.attribute_class = res[res.findIndex((x) => x.id == this.fId)].attribute_class;
            this.attribute_sub_class = res[res.findIndex((x) => x.id == this.fId)].attribute_sub_class;

            this.income_expense_class = res[res.findIndex((x) => x.id == this.fId)].income_expense_class;
            this.income_expense_sub_class = res[res.findIndex((x) => x.id == this.fId)].income_expense_sub_class;
          }
        },
        (error) => {}
      )
    );
  }
  getInsuranceAttributeFormData(currentFormId?: any) {
    this.isAttributeLoading.set(true);
    this.subscription.add(
      this.documentService.getVaultUserFormFinancialAttribute(this.userId, this.currentFormId ?? currentFormId).subscribe((formData) => {
        this.insuranceFormData = formData;
        this.attributesList.set(
          this.attributesList().map((attribute) => {
            return {
              ...attribute,
              getFormValues: this.getAttributeValue(attribute?.value?.vault_form_code) ?? null,
            };
          })
        );
        this.attributesList.set(this.attributesList().sort((a, b) => parseInt(a?.value?.order) - parseInt(b?.value?.order)));
        this.isAttributeLoading.set(false);
        this.cd.detectChanges();
      })
    );
  }

  getAttributeValue(vault_form_code: string) {
    if (!!this.insuranceFormData) {
      const attribute = this.insuranceFormData?.find((attribute) => attribute?.type == vault_form_code);
      if (!!attribute) return { ...JSON.parse(attribute?.value), effective_date: attribute?.effective_date, id: attribute?.id, attribute };
      if (!!!attribute) return null;
    } else {
      return undefined;
    }
  }

  getUpdateList(id, fId) {
    this.currentFormId = id;
    this.fId = fId;
    this.getList();
  }
  allAttributeData = undefined;
  handleJson(attribute) {
    this.subscription.add(
      this.documentService.getInsuranceAttribute().subscribe(
        (data) => {
          this.allAttributeData = data;
          if (this.findVaultForm(data, attribute?.toLowerCase()) != null) {
            this.attributesList.set([...this.attributesList(), this.findVaultForm(data, attribute?.toLowerCase())]);
            this.attributesList.set(this.attributesList().sort((a, b) => parseInt(a?.value?.order) - parseInt(b?.value?.order)));

            this.attributesList.set(
              this.attributesList().map((attribute) => {
                return {
                  ...attribute,
                  getFormValues: this.getAttributeValue(attribute?.value?.vault_form_code) ?? null,
                };
              })
            );
          }
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }
  findVaultForm(json, param) {
    for (let key in json) {
      if (typeof json[key] === 'object') {
        if (json[key]?.vault_form_code?.toLowerCase() === param) {
          return { key: key, value: json[key] };
        } else {
          const result = this.findVaultForm(json[key], param);
          if (result) {
            return result;
          }
        }
      }
    }
    return null;
  }
  premiumData = {};
  async openFormDialog(attributeData, attribute, type, balanceData?: any) {
    const dialogRef = this.dialog.open(AttributesDialogComponent, {
      width: '550',
      height: 'auto',
      minHeight: attribute?.value?.inputs?.length > 3 && attribute?.value?.vault_form_code !== 'has_premium' ? '400px' : '275px',
      panelClass: 'attributes-dialog',
      data: {
        mode: type,
        title: attribute?.key,
        userId: this.userId,
        currentFormId: this.currentFormId,
        triggeredFrom: attribute?.key,
        expenseCategories: [],
        attribute_type: 'insurance',
        attributeType: 'financial-attribute',
        income_expense_class: this.income_expense_class,
        income_expense_sub_class: this.income_expense_sub_class,
        ...(this.premiumData && { premiumData: this.premiumData }),
        existingAttributesList: attribute,
        attributeData: attributeData ?? {},
        balanceData: this.balanceRes ?? balanceData ?? '',
        attributeClasses: {
          attribute_class: this.attribute_class,
          attribute_sub_class: this.attribute_sub_class,
          income_expense_class: this.income_expense_class,
          income_expense_sub_class: this.income_expense_sub_class,
        },
        // getFormValues: this.getFormValues(attribute?.key) ?? this.getFormValues(attribute?.value?.vault_form_code) ?? null,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.attributesList.set([]);
          this.insuranceFormData = undefined;
          this.getDataForAttributes();
          this.balanceDataBehaviorSubject.handleBalanceData(data);
          if (!!data?.setupItem) {
            this.setupItemEmitter.emit(data?.setupItem);
          }
        }
      })
    );
  }
  getAttributeItemValue(input: { title: string; key: string; type: string; default?: string }) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar')) {
        return '$';
      }
      if (input?.type?.toLowerCase().includes('percentage')) {
        return '%';
      }
      if (input?.default?.toLowerCase() == 'not editable') {
        if (input?.type?.toLowerCase().includes('dollar')) {
          return '$';
        }
        if (input?.type?.toLowerCase().includes('percentage')) {
          return '%';
        }
        if (input?.type?.toLowerCase().includes('Numeric')) {
          return '-';
        }
        if (input?.type?.toLowerCase().includes('input')) {
          return '-';
        }
        return input?.type;
      }
      return '-';
    }
    return '-';
  }
  convertStringToNumber(input) {
    if (typeof input !== 'string') {
      return input; // Return input unchanged if it's not a string
    }
    // Remove commas and parse the string as a float
    const plainNumber = parseFloat(input.replace(/,/g, ''));
    return plainNumber;
  }

  handleStyleClassForAttributeValues(input: any, attribute: any, i) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar') || input?.type?.toLowerCase().includes('amount')) {
        return 'font-bold text-lg text-k-black';
      } else {
        return 'font-semibold text-base text-k-black';
      }
    }
    return 'font-semibold text-base text-k-black';
  }
  hasHistory(attribute: any) {
    return attribute?.value?.History && attribute?.value?.History.includes('Register');
  }
  getBalanceFormType(vault_form_code: string) {
    if (vault_form_code == 'has_premium') return 'Premium';
    return vault_form_code;
  }
  isBalanceAttribute(attribute) {
    if (attribute?.value?.History) return true;
    return false;
  }
  balanceRes;
  currentValue;
  currentDate;

  getBalance(needToPassCurrntUserId, type?: string) {
    this.subscription.add(
      this.documentService.gatLatestBalance(needToPassCurrntUserId, this.currentFormId, type ?? 'balance').subscribe((res) => {
        this.balanceRes = res.data;
        this.currentValue = res?.data?.value;
        this.currentDate = res?.data?.effective_date;
        // this.attributeList = res.data;m
        this.cd.detectChanges();
      })
    );
  }
  handleRegisterBalanceComponentEmitter(event) {
    this.getBalance(this.userId, event);
  }
  isDynamicAttribute(attribute) {
    return !!attribute?.value?.isDynamic ? true : false;
  }
  convertSwitchBooleanValueToString(value) {
    return value ? 'Yes' : 'No';
  }
}
